import { STAGE, resolveStage } from '@amzn/d2c-application-website-common';

export const getStage = (): STAGE => {
  return resolveStage('sojask');
};

/**
 * Stage to use for Roadie *external* service calls (merch APIs, ASIN catalog).
 * - `?asinStage=` on the URL wins; resolveStage normalizes case and aliases `dev` → `Beta`
 *   (the Roadie External service has no Dev stage; Dev portals point at Beta).
 * - No override → use the website's deploy-time stage.
 *
 * Template fetching (S3 config) is unaffected — that always uses sojask.
 */
export const getAsinStage = (): STAGE => {
  const param = new URLSearchParams(window.location.search).get('asinStage');
  return param ? resolveStage(param) : getStage();
};
